// Angular
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Services
import { CoreService } from '../../../../shared/services/core.service';

// Models
import { AppCleanup } from '../../../../shared/models';
import { StringOuterDiameter, StringViewModel } from '../models/string-view.model';

@Injectable({
	providedIn: 'root',
})
export class StringService extends AppCleanup {
	private stringUrl;

	constructor(private http: HttpClient) {
		super();
		this.stringUrl = `${this.apiUrl}api/asset/workstring`;
	}

	getStrings() {
		return this.http.get<StringViewModel[]>(this.stringUrl);
	}

	getString(id: number) {
		return this.http.get<StringViewModel>(`${this.stringUrl}/${id}`);
	}

	createString(string: StringViewModel) {
		return this.http.post<StringViewModel>(`${this.stringUrl}`, string);
	}

	updateString(string: StringViewModel) {
		return this.http.put<StringViewModel>(`${this.stringUrl}`, string);
	}

	deleteString(stringId: number) {
		return this.http.delete<StringViewModel>(`${this.stringUrl}/${stringId}`);
	}

	getOuterDiameters() {
		return this.http.get<StringOuterDiameter[]>(`${this.stringUrl}/outer-diameter`);
	}
}
